// extracted by mini-css-extract-plugin
export default {"template":"NoticePage_template__IEgyg","content":"NoticePage_content__6mr9O","header":"NoticePage_header__gksCR","header__title":"NoticePage_header__title__xksxP"};